import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, FormInstance, Input, InputNumber, Modal, Row, Select, Space } from "antd";
import { useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { AreaSeries } from "src/entity/settings/fugitive";
import { generateErrorMessage } from "src/utils/error-message";
import "./FugitiveComBySeriesModal.css";
import { BsTrashFill } from "react-icons/bs";
import { componentPalette } from "src/theme/component-palette";
import WrapCenter from "src/components/WrapCenter/WrapCenter";
import { AreaProps, CompanyAreaDetail } from "src/entity/company/company-response.entity";
import { getDetailComBySeries } from "src/services/settings.service";
import { Company } from "src/entity/map-company-user/map-company-user";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";
import { formatNumber } from "src/utils/process-number";

const FugitiveComBySeriesModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  areaMaster: AreaProps[];
  dataCompanyAreaDetails: CompanyAreaDetail[];
  companies: Company[];
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: AreaSeries) => void;
}) => {
  const { form, loading, open, mode, isDuplicate, areaMaster, dataCompanyAreaDetails, companies, onDuplicateChange, onCloseModal, onSave } =
    props;
  const [loadingModal, setLoadingModal] = useState<boolean>(false);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onSave(mode, values);
    } catch (error) {
      console.error(error);
    }
  };

  const checkDuplicateCompany = () => {
    const areaSeries = form.getFieldValue(["areaSeries"]) || [];
    const companyList = areaSeries?.map((item: any) => {
      return item?.companyId;
    });

    areaSeries?.forEach((item: any, index: number) => {
      const companyId = item?.companyId;
      const formError = [];
      const isDuplicate = companyList?.filter((item: string) => item === companyId).length > 1;
      if (isDuplicate) {
        formError.push({
          name: ["areaSeries", index, "companyId"],
          errors: ["Company must be unique"],
        });
      } else {
        formError.push({
          name: ["areaSeries", index, "companyId"],
          errors: [],
        });
      }
      form.setFields(formError);
    });
  };

  const checkDuplicateArea = (allValues: any) => {
    allValues.areaSeries?.forEach((areaSerie: any, idxAreaSerie: number) => {
      const areas = areaSerie?.areas;
      areas?.forEach((areaItem: any, idxAreaItem: number) => {
        const area = areaItem?.area;
        const isDuplicate = areas?.filter((itemArea: any) => itemArea?.area === area).length > 1;
        if (isDuplicate) {
          form.setFields([
            {
              name: ["areaSeries", idxAreaSerie, "areas", idxAreaItem, "area"],
              errors: ["Area must be unique for the company"],
            },
          ]);
          const errors = form.getFieldsError();
          // console.log(errors);
        } else {
          form.setFields([
            {
              name: ["areaSeries", idxAreaSerie, "areas", idxAreaItem, "area"],
              errors: [],
            },
          ]);
          const errors = form.getFieldsError();
          // console.log(errors);
        }
      });
    });
  };

  const handleCompanyChange = async (value: string, index: number) => {
    try {
      const query = `companyId=${value}`;
      setLoadingModal(true);
      const response = await getDetailComBySeries(query);
      const data = response?.data.data.data[0];
      if (data) {
        const { companyId, areas, _id } = data;
        // form.setFieldsValue({
        //   areaSeries: form
        //     .getFieldValue("areaSeries")
        //     .map((item: any, i: number) => (i === index ? { ...item, areas, companyId, _id } : item)),
        // });
        form.setFieldValue(["areaSeries", index, "companyId"], companyId);
        form.setFieldValue(["areaSeries", index, "areas"], areas);
        form.setFieldValue(["areaSeries", index, "_id"], _id);
      } else {
        form.setFieldValue(["areaSeries", index, "companyId"], value);
        form.setFieldValue(["areaSeries", index, "areas"], [{ area: "", series: [{ series: "" }] }]);
        // form.setFieldsValue({
        //   areaSeries: form
        //     .getFieldValue("areaSeries")
        //     .map((item: any, i: number) =>
        //       i === index ? { ...item, areas: [{ area: "", series: [{ series: "" }] }], companyId: value } : item,
        //     ),
        // });
      }
    } catch (error) {
      console.error("Error fetching series data for area:", error);
    } finally {
      setLoadingModal(false);
    }
  };

  const onChangeForm = (changeValue: any, allValues: any) => {
    checkDuplicateCompany();

    checkDuplicateArea(allValues);
  };

  const onFinish = (values: any) => {
    // console.log("Form Values:", values);
  };

  const CustomInputNumber = ({ precision = 2, ...props }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      onKeyDownNumberWithFixedDecimal(e, precision);
    };

    return <InputNumber min={0} max={100} precision={precision} onKeyDown={handleKeyDown} {...props} />;
  };

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={850}
        title={<ModalTitle title="Component by series" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading || loadingModal} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          size="middle"
          requiredMark={false}
          autoComplete="off"
          onValuesChange={onChangeForm}
          // onValuesChange={onChangeForm; onFormChange;}
          // onValuesChange={(changedValues, allValues) => {
          //   onChangeForm(changedValues, allValues); // Call your onChangeForm function
          //   onFormChange(changedValues, allValues); // Call your onFormChange function
          // }}
        >
          <Form.List name="areaSeries">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key} style={{ border: "1px solid #d9d9d9", padding: "16px", marginBottom: "3px" }}>
                    <Form.Item name={[name, "_id"]} style={{ display: "none" }}>
                      <Input />
                      <Input />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "companyId"]}
                      label={
                        <Row align="middle" justify="space-between" style={{ width: "100%" }}>
                          <Col>
                            <FormLabel label={"Company"} required />
                          </Col>
                          <Col>
                            {form.getFieldValue(["areaSeries"])?.length !== 1 && (
                              <BsTrashFill
                                size={16}
                                color={componentPalette.blueGrey}
                                onClick={() => remove(name)}
                                style={{ cursor: "pointer" }}
                                aria-label="Remove item"
                              />
                            )}
                          </Col>
                        </Row>
                      }
                      rules={[
                        { required: true, message: generateErrorMessage("Company") },
                        {
                          validator: async (_, value) => {
                            const allAreas = form.getFieldValue(["areaSeries"]) || [];
                            const companyList = allAreas?.map((item: any) => {
                              return item?.companyId;
                            });
                            const isDuplicate = companyList.filter((item: string) => item === value).length > 1;
                            if (isDuplicate) {
                              return Promise.reject(new Error("Company must be unique"));
                            }
                            handleCompanyChange(value, name);
                            return Promise.resolve();
                          },
                        },
                      ]}
                      style={{ marginBottom: 20 }}
                    >
                      <Select
                        // onChange={(value) => handleCompanyChange(value, name)}
                        loading={loadingModal}
                      >
                        {companies.map((item, index) => (
                          <Select.Option key={"company" + index} value={item._id}>
                            {item.companyName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.List name={[name, "areas"]}>
                      {(areaFields, { add: addArea, remove: removeArea }) => (
                        <>
                          {areaFields.map(({ key: areaKey, name: areaName, ...areaRestField }) => (
                            <div key={areaKey} style={{ border: "1px solid #d9d9d9", padding: "16px", marginBottom: "12px" }}>
                              <Form.Item
                                {...areaRestField}
                                name={[areaName, "area"]}
                                dependencies={["areas"]}
                                label={
                                  <Row align="middle" justify="space-between" style={{ width: "100%" }}>
                                    <Col>
                                      <FormLabel label={"Area"} required />
                                    </Col>
                                    <Col>
                                      <BsTrashFill
                                        size={16}
                                        color={componentPalette.blueGrey}
                                        onClick={() => {
                                          const allAreas = form.getFieldValue(["areaSeries", name, "areas"]) || [];
                                          if (allAreas.length > 1) {
                                            removeArea(name);
                                            // checkDuplicateArea();
                                            const areaList = allAreas?.map((area: any) => {
                                              return area?.area;
                                            });

                                            // Count duplicates
                                            const uniqueItems = new Set(areaList);
                                            const dupCount = areaList.length - uniqueItems.size;
                                            if (dupCount > 1) {
                                              form.setFields([
                                                {
                                                  name: ["areaSeries", name, "areas", areaName, "area"],
                                                  errors: ["Area must be unique for the company"],
                                                },
                                              ]);
                                            } else {
                                              form.setFields([
                                                {
                                                  name: ["areaSeries", name, "areas", areaName, "area"],
                                                  errors: [],
                                                },
                                              ]);
                                            }
                                          }
                                        }}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Col>
                                  </Row>
                                }
                                rules={[
                                  { required: true, message: generateErrorMessage("Area") },
                                  {
                                    validator: (_, value) => {
                                      // console.log("validator value", value);
                                      const allAreas = form.getFieldValue(["areaSeries", name, "areas"]) || [];
                                      // console.log("validator", allAreas);
                                      const isDuplicate = allAreas?.filter((area: any) => area?.area === value).length > 1;
                                      if (isDuplicate) {
                                        form.setFields([
                                          {
                                            name: ["areaSeries", name, "areas", areaName, "area"],
                                            errors: ["Area must be unique for the company"],
                                          },
                                        ]);
                                        return Promise.reject(new Error("Area must be unique for the companyxxx"));
                                      }
                                      form.setFields([
                                        {
                                          name: ["areaSeries", name, "areas", areaName, "area"],
                                          errors: [],
                                        },
                                      ]);
                                      return Promise.resolve();
                                    },
                                  },
                                ]}
                                style={{ marginBottom: 20 }}
                              >
                                <Select loading={loadingModal} notFoundContent="No areas found">
                                  {dataCompanyAreaDetails?.map((item) => {
                                    const currentArea = form.getFieldValue(["areaSeries", name, "areas", areaName, "area"]);
                                    if (item?.companyId === form.getFieldValue(["areaSeries", name, "companyId"])) {
                                      const areas = item?.areas || [];
                                      const matchArea = areas.find((itemArea) => itemArea._id === currentArea);
                                      if (!matchArea) {
                                        form.setFieldValue(["areaSeries", name, "areas", areaName, "area"], "");
                                        // form.setFields([
                                        //   {
                                        //     name: ["areaSeries", name, "areas", areaName, "area"],
                                        //     value: "",
                                        //     // errors: [generateErrorMessage("Area")],
                                        //   },
                                        // ]);
                                      }
                                      return areas.length > 0 ? (
                                        areas.map((area: any) => (
                                          <Select.Option key={`area-${area?._id}`} value={area?._id}>
                                            {area?.areaName || ""}
                                          </Select.Option>
                                        ))
                                      ) : (
                                        <Select.Option key="no-area" value="">
                                          {""}
                                        </Select.Option>
                                      );
                                    }
                                    return null;
                                  })}
                                </Select>
                              </Form.Item>
                              <Form.List name={[areaName, "series"]}>
                                {(seriesFields, { add: addSeries, remove: removeSeries }) => (
                                  <>
                                    {seriesFields.map(({ key: seriesKey, name: seriesName, ...seriesRestField }) => (
                                      <Space
                                        key={seriesKey}
                                        align="baseline"
                                        style={{ display: "flex", marginBottom: 4, paddingBottom: 0 }}
                                      >
                                        <Form.Item
                                          {...seriesRestField}
                                          name={[seriesName, "series"]}
                                          label={<FormLabel label="Series" required />}
                                          rules={[
                                            { required: true, message: generateErrorMessage("Series") },
                                            {
                                              validator: async (_, value) => {
                                                const allAreas = form.getFieldValue(["areaSeries", name, "areas"]) || [];
                                                const allSeries = allAreas
                                                  .flatMap((item: any) => item?.series || [])
                                                  .filter((seriesItem: any) => seriesItem?.series)
                                                  .map((seriesItem: any) => seriesItem?.series);

                                                // Check for duplicates
                                                const isDuplicate = allSeries.filter((series: string) => series === value).length > 1;

                                                if (isDuplicate) {
                                                  return Promise.reject(new Error("Series must be unique for the area"));
                                                }

                                                return Promise.resolve();
                                              },
                                            },
                                          ]}
                                          style={{ marginBottom: 0 }}
                                        >
                                          <Input />
                                        </Form.Item>

                                        <Form.Item label={<FormLabel label="Emission" />} style={{ marginBottom: 0 }}>
                                          <Space align="baseline" style={{ display: "flex", gap: 4 }}>
                                            <span>BZ% </span>
                                            <Form.Item {...seriesRestField} name={[seriesName, "bz"]} style={{ marginBottom: 0 }}>
                                              <CustomInputNumber />
                                            </Form.Item>

                                            <span>BD% </span>
                                            <Form.Item {...seriesRestField} name={[seriesName, "bd"]} style={{ marginBottom: 0 }}>
                                              <CustomInputNumber />
                                            </Form.Item>

                                            <span>EDC% </span>
                                            <Form.Item {...seriesRestField} name={[seriesName, "edc"]} style={{ marginBottom: 0 }}>
                                              <CustomInputNumber />
                                            </Form.Item>

                                            <span>VCM% </span>
                                            <Form.Item {...seriesRestField} name={[seriesName, "vcm"]} style={{ marginBottom: 0 }}>
                                              <CustomInputNumber />
                                            </Form.Item>

                                            <BsTrashFill
                                              size={16}
                                              color={componentPalette.blueGrey}
                                              style={{ cursor: "pointer", marginLeft: 8 }}
                                              // onClick={() => removeSeries(seriesName)}
                                              onClick={() => {
                                                const allAreas = form.getFieldValue(["areaSeries", name, "areas"]) || [];
                                                const currentArea = allAreas[areaName];
                                                const allSeries = currentArea?.series || [];
                                                if (allSeries.length > 1) {
                                                  removeSeries(seriesName);
                                                } else {
                                                  // console.log("Cannot delete the last series.");
                                                }
                                              }}
                                            />
                                          </Space>
                                        </Form.Item>
                                      </Space>
                                    ))}

                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                      <Button type={"primary"} onClick={() => addSeries()} loading={loadingModal}>
                                        <WrapCenter>
                                          <PlusCircleOutlined />
                                        </WrapCenter>
                                      </Button>
                                    </div>
                                  </>
                                )}
                              </Form.List>
                            </div>
                          ))}

                          <Form.Item>
                            <Button
                              type="dashed"
                              onClick={() => {
                                // addArea();
                                addArea({
                                  area: "",
                                  series: [{ series: "" }], // Add default series when adding a new area
                                });
                              }}
                              icon={
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: componentPalette.primary,
                                    borderRadius: "4px",
                                    width: "40px",
                                    height: "32px",
                                    color: "#fff",
                                  }}
                                >
                                  <WrapCenter>
                                    <PlusCircleOutlined />
                                  </WrapCenter>
                                </span>
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                borderColor: "#1890ff",
                                width: "100%",
                                justifyContent: "center",
                                height: "48px",
                                fontSize: "16px",
                              }}
                            >
                              Add Area
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  </div>
                ))}

                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => {
                      add();
                    }}
                    icon={
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: componentPalette.primary,
                          borderRadius: "4px",
                          width: "40px",
                          height: "32px",
                          color: "#fff",
                        }}
                      >
                        <WrapCenter>
                          <PlusCircleOutlined />
                        </WrapCenter>
                      </span>
                    }
                    // icon={
                    //   <Button type={"primary"} onClick={() => add()} loading={loadingModal}>
                    //     <WrapCenter>
                    //       <PlusCircleOutlined />
                    //     </WrapCenter>
                    //   </Button>
                    // }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderColor: "#1890ff",
                      width: "100%",
                      justifyContent: "center",
                      height: "48px",
                      fontSize: "16px",
                    }}
                  >
                    Add Company
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </div>
  );
};

export default FugitiveComBySeriesModal;
